import { clsx } from 'clsx';
import { Dialog, Button } from '@teachstonellc/component-library';

interface ConfirmationModalProps {
  /**Title for the modal */
  title: React.ReactNode;

  /**Content message for the modal */
  message: React.ReactNode;

  /**Text associated with the text button to cancel the modal action */
  dismissButtonText: string;

  /**Text associated with the text button to complete the modal action */
  confirmButtonText: string;

  /**Function call on confirmation */
  onConfirm: () => void;

  /**Function called when the dismiss button is clicked */
  onCancel: () => void;

  /**Function called when the modal is dismissed via Escape, the overlay, or the X button */
  onClose: () => void;

  /**true when modal is open */
  isOpen: boolean;

  /**true on KnowledgeTest */
  knowledgeTest?: boolean;

  /**true when the Knowledge Test has all the answers completed */
  isReadyToSubmit?: boolean;
}

function ConfirmationModal({
  title,
  message,
  dismissButtonText,
  confirmButtonText,
  onConfirm,
  onCancel,
  onClose,
  isOpen,
  knowledgeTest,
  isReadyToSubmit
}: ConfirmationModalProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => !open && onClose()}
      title={title}
      titleClassName="text-center text-[#364A5E] pt-5"
      contentClassName={clsx(
        'max-w-[92vw] !rounded-[17px]',
        knowledgeTest
          ? 'sm:!w-[942px] md:!px-12'
          : 'sm:max-w-[642px] !px-14 md:!px-[120px]'
      )}
      overlayClassName="!bg-[rgba(0,0,0,0.63)]"
      actionButton={
        <div className="w-full flex gap-4 justify-center pt-4 pb-12 px-4">
          <Button variant="secondary" className="flex-1" onClick={onCancel}>
            {dismissButtonText}
          </Button>
          <Button
            variant="primary"
            className="flex-1"
            onClick={onConfirm}
            disabled={knowledgeTest ? !isReadyToSubmit : false}
          >
            {confirmButtonText}
          </Button>
        </div>
      }
    >
      {message}
    </Dialog>
  );
}

export default ConfirmationModal;
